import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../encoding/AbstractEncoder.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NoOpEncoderClass;
function NoOpEncoder() {
  if (NoOpEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor() {
        return new.target.z1z();
      }
      static z1z() {
        NoOpEncoder_instance = null;
        var $this = this.l1s();
        NoOpEncoder_instance = $this;
        $this.y1z_1 = EmptySerializersModule();
        return $this;
      }
      h1s() {
        return this.y1z_1;
      }
      n1s(value) {
        return Unit_instance;
      }
      o1s() {
        return Unit_instance;
      }
      p1s(value) {
        return Unit_instance;
      }
      q1s(value) {
        return Unit_instance;
      }
      r1s(value) {
        return Unit_instance;
      }
      s1s(value) {
        return Unit_instance;
      }
      t1s(value) {
        return Unit_instance;
      }
      u1s(value) {
        return Unit_instance;
      }
      v1s(value) {
        return Unit_instance;
      }
      w1s(value) {
        return Unit_instance;
      }
      x1s(value) {
        return Unit_instance;
      }
      y1s(enumDescriptor, index) {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'NoOpEncoder');
    NoOpEncoderClass = $;
  }
  return NoOpEncoderClass;
}
var NoOpEncoder_instance;
function NoOpEncoder_getInstance() {
  if (NoOpEncoder_instance === VOID)
    NoOpEncoder().z1z();
  return NoOpEncoder_instance;
}
//region block: exports
export {
  NoOpEncoder_getInstance as NoOpEncoder_getInstanceajja35qtb1df,
};
//endregion

//# sourceMappingURL=NoOpEncoder.mjs.map
